<script>
import HrbrPdfViewer from '../PdfViewer/HrbrPdfViewer.vue';
import SuperdocViewer from "@/shared/components/SuperdocViewer/SuperdocViewer.vue";
import {fieldAnnotationHelpers} from "@harbour-enterprises/superdoc";

export default {
  name: 'HrbrVerificationsConsent',
  components: {
    SuperdocViewer,
    HrbrPdfViewer,
  },
  props: {
    checkConsents: {
      type: Array,
      required: true,
    },
    inputValues: {
      type: Object,
      required: true,
    },
    companyName: {
      type: String,
      required: true,
    },
    linkDisplayId: {
      type: String,
      required: true,
    },
    requestTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      defaultIconsForSections: ['star', 'check'],
      htmlData: null,
      activeConsent: null,
      activeConsentFile: null,
      activeConsentIndex: 0,
      isLoadedConsent: false,
      isSendCopy: true,
      typedSignature: '',
      itemValues: [],
      signaturepad: null,
      item: 'SETTINGS',
      allConsentsSigned: false,
      headerCtas: [
        {
          id: 'download',
          label: 'Download',
          icon: 'file-arrow-down',
          type: 'secondary',
        },
      ]
    };
  },
  computed: {
    isAvailableFooterInputs() {
      return (
        this.activeConsent.inputs.hasOwnProperty('SIGNATUREINPUT') ||
        this.activeConsent.inputs.hasOwnProperty('SIGNATUREPAD') ||
        this.activeConsent.inputs.hasOwnProperty('CHECKBOXINPUT')
      );
    },
    isAllConsentInputsFilled() {
      let isFilledRequiredInputs = true;
      let inputs = Object.keys(this.activeConsent.inputs);
      //Check if signature is filled only if signature input is required for current consent
      if (inputs && inputs.includes('SIGNATUREINPUT')) {
        isFilledRequiredInputs = !!this.typedSignature.trim();
      }
      else if (inputs && inputs.includes('SIGNATUREPAD')) {
        isFilledRequiredInputs =
          this.activeConsent.inputs['SIGNATUREPAD'] != null &&
          !!this.activeConsent.inputs['SIGNATUREPAD'].trim();
      }
      return isFilledRequiredInputs;
    },
    pdfViewerComponentData() {
      return {
        props: {
          class: 'hrbr-agreement-editor-check-consent__pdf-viewer',
          file: this.activeConsent.pdfbase64,
          fileName: this.activeConsent.consenttitle,
          fileInfo: {
            fileId: this.activeConsent.id,
          },
          outputScale: 2,
          mode: 'view',
        },
      };
    },
    superdocViewerComponentData() {
      let headerCtas = [
        {
          id: 'download',
          label: 'Download',
          icon: 'file-arrow-down',
          type: 'secondary',
        },
      ];
      return {
        props: {
          name:this.activeConsent.consenttitle,
          id:this.activeConsent.id,
          source:this.activeConsent.htmldata,
          headerCtas,
          modules:{
            'hrbr-fields': {},
          },
        },
      };
    },
  },
  methods: {
    closeModal() {
      this.$parent.close();
    },
    processConsentFile() {
      this.activeConsent = this.checkConsents[this.activeConsentIndex];
      this.activeConsent.itemvalues = [];
      if (!this.activeConsent.isloaded) {
        this.isLoadedConsent = false;
      }
      if (!this.activeConsent.ispdf) {

        if (this.activeConsent?.htmldata && !this.activeConsent?.htmldata.startsWith('<')) {
          const wrapper = document.createElement('div');
          wrapper.innerHTML = this.activeConsent?.htmldata;
          const html = wrapper.outerHTML;
          wrapper.remove();
          this.htmlData = html;
          this.activeConsent.htmldata = html;
        }

        this.$emit('update-html-data', this.htmlData);
        setTimeout(() => {
          const htmlContainer = document.querySelector('.superdoc-html-viewer__content');
          if(htmlContainer) {
            this.updateSuperdocAnnotationText(htmlContainer);
          }
        }, 500);
      } else {
        this.htmlData = null;
      }

      this.activeConsent.vieweddatetimeepochms = new Date().getTime();
      this.$emit('on-audit-trail-update', this.activeConsent, 'viewed');
      this.activeConsent.isviewed = true;
    },
    onAgreedConsent() {
      this.activeConsent.completeddatetimeepochms = new Date().getTime();
      this.$emit('on-audit-trail-update', this.activeConsent, 'accepted');
      this.activeConsent.iscompleted = true;
      if (this.activeConsentIndex === this.checkConsents.length - 1) {
        this.allConsentsSigned = true;
        this.$emit('on-consents-given', this.checkConsents);
        this.closeModal();
        return;
      }
      this.activeConsentIndex += 1;
      this.typedSignature = '';
      this.isSendCopy = true;
      this.processConsentFile();


    },
    updateHtmlData() {
      this.$emit('update-html-data', this.htmlData);
    },
    updateSuperdocAnnotationText(htmlContainer = null) {

      const annotations = htmlContainer.querySelectorAll('.annotation');

      annotations.forEach((annotation) => {
        const itemId = annotation.getAttribute('data-itemid');
        const itemFieldType = annotation.getAttribute('data-itemfieldtype');
        let newValue = null;
        if (itemFieldType === 'COMPANYNAMETEXTINPUT') {
          newValue = this.companyName;
        } else if (itemFieldType === 'NAMETEXTINPUT') {
          const firstName = this.inputValues.first_name;
          const lastName = this.inputValues.last_name;

          newValue = `${firstName} ${lastName}`;
        } else if (itemFieldType === 'SIGNDATEINPUT') {
          newValue = this.getFormattedDate(null, 'mmm dd yyyy');
        } else if (itemFieldType === 'CHECKBOXINPUT') {
          newValue = this.isSendCopy;
          const annotationText = annotation.querySelector('.annotation-text');
          annotationText.innerHTML = ' ';
          if (newValue) {
            newValue = 'x';
          } else {
            newValue = ' ';
          }
          this.activeConsent.inputs[itemFieldType] = newValue;
        }
        if (newValue) {
          const annotationText = annotation.querySelector('.annotation-text');
          annotationText.innerHTML = newValue;
          let itemValue = {};
          itemValue['itemid'] = itemId;
          itemValue['itemlinkvalue'] = newValue;
          if (!this.activeConsent.itemvalues.some((e) => e.itemid === itemId)) {
            this.activeConsent.itemvalues.push(itemValue);
          } else {
            let l = this.activeConsent.itemvalues.find((e) => e.itemid === itemId);
            l['itemlinkvalue'] = newValue;
          }
          this.activeConsent.inputs[itemFieldType] = newValue;
        }
      });
    },
    setCheckbox(newValue) {
      const htmlContainer = document.querySelector('.superdoc-html-viewer__content');
      const annotations = htmlContainer.querySelectorAll('.annotation');

      annotations.forEach((annotation) => {
        const itemId = annotation.getAttribute('data-itemid');
        const itemFieldType = annotation.getAttribute('data-itemfieldtype');
        if (itemFieldType === 'CHECKBOXINPUT') {
          const annotationText = annotation.querySelector('.annotation-text');
          if (newValue) {
            newValue = 'x';
            annotationText.innerHTML = newValue;
          } else {
            newValue = ' ';
            annotationText.innerHTML = newValue;
          }
          let itemValue = {};
          itemValue['itemid'] = itemId;
          itemValue['itemlinkvalue'] = ' ';
          if (!this.activeConsent.itemvalues.some((e) => e.itemid === itemId)) {
            this.activeConsent.itemvalues.push(itemValue);
          } else {
            let l = this.activeConsent.itemvalues.find((e) => e.itemid === itemId);
            l['itemlinkvalue'] = newValue;
          }
          this.activeConsent.inputs[itemFieldType] = newValue;
        }
      });
    },
    setSignature(newValue, text) {
      if (!this.activeConsent.ispdf) {
        const htmlContainer = document.querySelector('.superdoc-html-viewer__content');
        const annotations = htmlContainer.querySelectorAll('.annotation');

        annotations.forEach((annotation) => {
          const itemId = annotation.getAttribute('data-itemid');
          const itemFieldType = annotation.getAttribute('data-itemfieldtype');
          if (itemFieldType === 'SIGNATUREINPUT') {
            annotation.innerHTML = `<img src="${newValue}" />`;
            let itemValue = {};
            itemValue['itemid'] = itemId;
            itemValue['itemlinkvalue'] = newValue;
            if (!this.activeConsent.itemvalues.some((e) => e.itemid === itemId)) {
              this.activeConsent.itemvalues.push(itemValue);
            } else {
              let l = this.activeConsent.itemvalues.find((e) => e.itemid === itemId);
              l['itemlinkvalue'] = newValue;
            }
            this.activeConsent.inputs[itemFieldType] = newValue;
          }
        });
      } else {
        this.activeConsent.inputs['SIGNATUREINPUT'] = newValue;
      }
      if (!text || !text.trim()) {
        this.activeConsent.inputs['SIGNATUREINPUT'] = null;
      }
    },
    drawText: function (text) {
      const fontFamily = 'La Belle Aurore';
      this.typedSignature = text;
      //If no typed signature return
      if (!text || !text.trim()) {
        this.activeConsent.inputs['SIGNATUREINPUT'] = null;
      }
      let cc = document.createElement('canvas');
      let canvasContext = cc.getContext('2d');
      cc.width = 572;
      cc.height = 175;
      canvasContext.textBaseline = 'top';
      canvasContext.textAlign = 'left';

      //Resize the typed signature to fit in the agreement
      let initialSize = 60 - text.length;
      initialSize = initialSize <= 10 ? 10 : initialSize;
      initialSize = initialSize > 25 ? 25 : initialSize;
      canvasContext.font = initialSize + 'px ' + fontFamily;
      let canvasW = cc.width;
      let newWidth = this.$refs.signatureinputfield.$refs.input.offsetWidth;
      let newHeight = this.$refs.signatureinputfield.$refs.input.offsetHeight;

      if (newWidth > canvasW) {
        let ratio =
          this.$refs.signatureinputfield.offsetWidth / this.$refs.signatureinputfield.offsetHeight;
        newWidth = cc.width;
        newHeight = newWidth / ratio;
        if (newHeight > cc.height) {
          newHeight = cc.height;
          newWidth = newHeight * ratio;
        }
      }

      //Set the x, y coordinates to center the signature on the canvas
      let centerX = (canvasW - newWidth) / 2 + 40;
      let centerY = 123;
      canvasContext.fillText(text, centerX, centerY);
      let dataUrl = cc.toDataURL('image/png');
      dataUrl = this.getTrimFittedCanvasDataUrl(cc, canvasContext);
      this.setSignature(dataUrl, text);
    },
    async getCheckConsentHtmlData(consent) {
      consent.isloaded = false;
      try {
        const res = await this.$harbourData.post(
            '/agreelinkdata?agreelinkdata-getcheckconsenthtmldata',
            {
              requesttype: 'agreelinkdata-getcheckconsenthtmldata',
              consenttype: consent.consenttype,
            }
        );
        consent.isloaded = true;
        this.isLoadedConsent = consent.isloaded;
        consent.htmldata = res.data.consent_html_data;

        // Call processConsentFile only when ready
        if (this.activeConsentIndex === 0) {
          this.processConsentFile();
        }
        this.$forceUpdate();
      } catch (err) {
        consent.isloaded = false;
        console.error(err);
      }
    },
    async getCheckConsentPdfBase64(consent) {
      const consentType = consent.consenttype;
      consent.isloaded = false;
      this.isLoadedConsent = consent.isloaded;
      try {
        const res = await this.$harbourData.post(
          '/agreelinkdata?agreelinkdata_get_check_consent_pdffile',
          {
            requesttype: 'agreelinkdata_get_check_consent_pdffile',
            consenttype: consentType,
          },
        );
        consent.isloaded = true;
        this.isLoadedConsent = consent.isloaded;
        consent.pdfbase64 = res.data.pdfbase64;
        this.$forceUpdate();
      } catch (err) {
        console.error(err);
      }
    },
    async getConsentsDocuments() {
      for (const consent of this.checkConsents) {
        consent.isrequired = true;
        this.isLoadedConsent = consent.isloaded;
        if (consent.htmldata) {
          const wrapper = document.createElement('div');
          wrapper.innerHTML = consent.htmldata;
          const html = wrapper.outerHTML;
          wrapper.remove();
          consent.htmldata = html;
          consent.isloaded = true;
          continue;
        }
        if (consent.triggers.state) {
          const checkState = this.inputValues.state.toLowerCase();
          if (!consent.triggers.state.includes(checkState)) {
            consent.isrequired = false;
          }
        }
        if (consent.triggers.county) {
          const checkCounty = this.inputValues.county.toLowerCase();
          if (!consent.triggers.county.includes(checkCounty)) {
            consent.isrequired = false;
          }
        }

        if (consent.isrequired) {
          if (!consent.ispdf) {
            await this.getCheckConsentHtmlData(consent);
          } else {
            await this.getCheckConsentPdfBase64(consent);
          }
        }
      }
    },
    updateSignature(item, newValue) {
      this.activeConsent.inputs['SIGNATUREPAD'] = newValue;
    },
    handleSigpadReady(l) {
      let fieldAnnotations = fieldAnnotationHelpers.getAllFieldAnnotations(l.state);
      console.log(fieldAnnotations)
    }
  },
  created() {
    this.activeConsent = this.checkConsents[this.activeConsentIndex];
    this.activeConsent.itemvalues = [];
    this.getConsentsDocuments();
  },
};
</script>

<template>
  <div id="hrbr-certn-checks-modal-card" class="modal-card" ref="modal">
    <header class="modal-card-head">
      <b-steps
        v-model="activeConsentIndex"
        position="bottom"
        label-position="right"
        :size="null"
        :has-navigation="false">
        <b-step-item
          v-for="(consent, index) in checkConsents.filter((i) => i.isrequired)"
          :key="consent.id"
          :step="index + 1"
          :label="consent.consenttitle"
          :clickable="false">
        </b-step-item>
      </b-steps>
    </header>
    <section class="modal-card-body" style="padding: 0em" ref="modalCardBody">
      <b-loading :active="!isLoadedConsent" :is-full-page="false" :can-cancel="false"></b-loading>
      <div class="b-sidebar">
        <div class="sidebar-content is-light">
          <b-steps
            v-model="activeConsentIndex"
            position="bottom"
            label-position="right"
            :size="null"
            :has-navigation="false"
            vertical>
            <b-step-item
              v-for="(consent, index) in checkConsents.filter((i) => i.isrequired)"
              :key="consent.id"
              :step="index + 1"
              :label="consent.consenttitle"
              :clickable="false">
            </b-step-item>
          </b-steps>
        </div>
      </div>
      <div class="templates-content">
        <div class="card-content template-document-card">

          <SuperdocViewer style="padding-bottom: 160px"
              v-if="!activeConsent.ispdf && activeConsent.htmldata"
              :key="activeConsent.id"
              v-bind="superdocViewerComponentData.props"
              />
          <HrbrPdfViewer
            v-else-if="isLoadedConsent"
            v-bind="pdfViewerComponentData.props"
            v-on="pdfViewerComponentData.events">
          </HrbrPdfViewer>
        </div>
        <div :class="isAvailableFooterInputs ? 'footer-inputs' : 'footer-no-inputs'">
          <div v-if="isAvailableFooterInputs" class="consents-inputs">

            <vue-signature-pad
              v-if="activeConsent.inputs.hasOwnProperty('SIGNATUREPAD')"
              ref="signaturepad"
              :item="item"
              :username="inputValues.first_name"
              :signingsetting="'draw'"
              :inputchange="updateSignature">
            </vue-signature-pad>

            <b-input
              v-if="activeConsent.inputs.hasOwnProperty('SIGNATUREINPUT')"
              placeholder="Type your signature"
              style="width: 75%"
              icon="signature"
              icon-pack="fal"
              ref="signatureinputfield"
              v-model="typedSignature"
              @input="drawText">
            </b-input>
            <div
              v-if="activeConsent.inputs.hasOwnProperty('SIGNATUREINPUT')"
              class="signature-footer">
              I agree this is a legal representation of my signature and is legally binding upon
              electronically signing
            </div>
            <b-checkbox
              v-if="activeConsent.inputs.hasOwnProperty('CHECKBOXINPUT')"
              class="certn-send-copy-checkbox"
              @input="
                (evt) => {
                  setCheckbox(evt);
                }
              "
              :key="activeConsent.id + '-is-send-copy'"
              v-model="isSendCopy">
              <span
                >Please check this box if you would like to receive a free copy of any consumer
                report obtained by the Company about you.
              </span>
            </b-checkbox>
          </div>
          <div class="consents-buttons">
            <b-checkbox
              class="certn-send-copy-checkbox"
              :key="activeConsent.id + '-is-send-email'"
              v-model="activeConsent.issendbyemail">
              <span>Send copy to my email. </span>
            </b-checkbox>
            <b-button @click="onAgreedConsent" :disabled="allConsentsSigned || !isAllConsentInputsFilled" type="is-success"
              >I AGREE</b-button
            >
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="postcss" scoped></style>

<style>
#hrbr-certn-checks-modal-card .modal-card-head {
  display: none;
}
#hrbr-certn-checks-modal-card .modal .animation-content .modal-card {
  height: 90vh;          /* was 600px; use viewport */
  max-height: 90vh;
  z-index: 300;
}
#hrbr-certn-checks-modal-card .step-ctn {
  cursor: grab;
}

#hrbr-certn-checks-modal-card .step-details {
  background-color: transparent;
  text-align: left;
  padding-left: 10px;
}

#hrbr-certn-checks-modal-card .steps {
}

#hrbr-certn-checks-modal-card .b-sidebar {
  width: 41%;
  overflow: auto;
}
#hrbr-certn-checks-modal-card .sidebar-content {
  height: 100%;
}

#hrbr-certn-checks-modal-card .sidebar-content .step-marker {
  min-width: 2rem;
  min-height: 2rem;
}

#hrbr-certn-checks-modal-card .step-details .step-title {
  font-size: 15px;
}

#hrbr-certn-checks-modal-card .step-items .step-item.is-active .step-marker {
  background-color: #fff;
  border-color: #2d71ad;
  color: #2d71ad;
}

#hrbr-certn-checks-modal-card .step-items .step-item.is-active .step-title {
  color: #2d71ad;
}

#hrbr-certn-checks-modal-card .step-items .step-item .step-marker {
  background-color: #fff;
  border-color: #2d71ad73;
  color: #2d71ad73;
}

#hrbr-certn-checks-modal-card .step-items .step-item .step-title {
  color: #2d71ad73;
}

#hrbr-certn-checks-modal-card
  .b-steps.is-vertical
  > .steps.has-label-right
  .step-items
  .step-item:not(:first-child)::before {
  display: none;
}

#hrbr-certn-checks-modal-card .modal-card-body {
  padding: 0;
  display: flex;
  background-color: #f8f9fb;
  border-radius: 6px;
  overflow: hidden; /* hide under the sticky footer edges */
}
#hrbr-certn-checks-modal-card .hrbr-superdoc-viewer__container-inner, .superdoc-html-viewer__content {
  width: 100% !important;
  min-width: unset !important;
}
#hrbr-certn-checks-modal-card .hrbr-superdoc-viewer{
  min-width:unset !important;
}
#hrbr-certn-checks-modal-card .hrbr-superdoc-viewer .superdoc{
  height: 100%;
}

#hrbr-certn-checks-modal-card .step-ctn .edit-icon-btn,
#hrbr-certn-checks-modal-card .step-ctn .delete {
  opacity: 0;
  transition: 0.1s;
  cursor: pointer;
}

#hrbr-certn-checks-modal-card .step-ctn:hover .edit-icon-btn {
  opacity: 1;
}

#hrbr-certn-checks-modal-card .b-steps {
  margin-left: 10px;
  margin-right: 10px;
}

#hrbr-certn-checks-modal-card .b-steps .steps {
  font-size: 12px;
  min-height: 2rem;
}

#hrbr-certn-checks-modal-card .step-ctn:hover .delete {
  opacity: 1;
}

#hrbr-certn-checks-modal-card .templates-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;               /* CRUCIAL so flex child can shrink and scroll */
  overflow-y: auto;            /* only this scrolls */
  -webkit-overflow-scrolling: touch; /* smooth iOS scroll */
  overscroll-behavior: contain;
}


#hrbr-certn-checks-modal-card .template-document-card {
  width: 100%;
  height: 100%;
  padding: 0px;
}
#hrbr-certn-checks-modal-card .control.has-icons-left .icon,
.control.has-icons-right .icon {
  color: black;
}
#hrbr-certn-checks-modal-card .input {
  border-color: black;
}
#hrbr-certn-checks-modal-card .footer-inputs,
#hrbr-certn-checks-modal-card .footer-no-inputs {
  position: sticky;    /* was absolute */
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;         /* was 71% on desktop */
  background-color: #fafafa;
  padding: 10px;
  box-shadow: 0 -4px 10px rgba(0,0,0,.06), inset 0 1px 4px rgba(10,10,10,.06);
  z-index: 10;
}

#hrbr-certn-checks-modal-card .footer-inputs {
  height: 160px;
}

#hrbr-certn-checks-modal-card .consents-buttons {
  display: flex;
  justify-content: space-between;
}


#hrbr-certn-checks-modal-card .certn-send-copy-checkbox {
  padding-top: 10px;
}

#hrbr-certn-checks-modal-card .consents-inputs {
  padding-bottom: 10px;
  font-size: 15px;
  padding-top: 10px;
}

#hrbr-certn-checks-modal-card .consents-inputs .input {
  font-family: 'La Belle Aurore';
}


#hrbr-certn-checks-modal-card .button.is-success {
  width: 125px;
}

#hrbr-certn-checks-modal-card .button.is-ghost {
  color: #2d71ad;
  font-size: 14px;
}
#hrbr-certn-checks-modal-card .signature-footer {
  font-size: 13px;
  color: rgb(159, 159, 159);
  position: relative;
  width: 75%;
}
#hrbr-certn-checks-modal-card .description {
  font-size: 13px;
  color: rgb(159, 159, 159);
  text-align: center;
  position: relative;
  top: -5px;
}
@media only screen and (min-width: 800px) {
  #hrbr-certn-checks-modal-card {
    width: 900px !important;
    height: 600px;
    z-index: 300;
  }
}
@media only screen and (max-width: 768px) {
  #hrbr-certn-checks-modal-card { height: 90vh; }
  #hrbr-certn-checks-modal-card .b-sidebar { display: none; }
  #hrbr-certn-checks-modal-card .modal-card-head { display: flex; }
  #hrbr-certn-checks-modal-card .footer-inputs,
  #hrbr-certn-checks-modal-card .footer-no-inputs { width: 100%; }
  #hrbr-certn-checks-modal-card .consents-inputs {padding-bottom: 0px;}
  #hrbr-certn-checks-modal-card .signature-footer {font-size: 8px;}
}

/* Optional: hint there’s more content under the footer */
#hrbr-certn-checks-modal-card .templates-content::after {
  content: "";
  position: sticky;
  bottom: 160px; /* matches .footer-inputs height; use 0 for .footer-no-inputs */
  display: block;
  height: 0;
  pointer-events: none;
}
</style>
